var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockClosedIcon = function SvgLockClosedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.25 19.25h-8.437v-6.562a10.312 10.312 0 0 0-20.626 0v6.562H11.75A3.75 3.75 0 0 0 8 23v26.25A3.75 3.75 0 0 0 11.75 53h37.5A3.75 3.75 0 0 0 53 49.25V23a3.75 3.75 0 0 0-3.75-3.75M30.5 38.938a2.813 2.813 0 1 1 0-5.626 2.813 2.813 0 0 1 0 5.626m6.563-19.688H23.937v-6.562a6.562 6.562 0 1 1 13.125 0z"
  })));
};
export default SvgLockClosedIcon;